import type { Database } from "@pollen/schema";

export const useDatabaseClient = () => useSupabaseClient<Database>();
